import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class ResourceMediaControlOptions extends LayoutRenderLayoutItemOptions {
	filter?: string[];
	readDescriptionFromData?: {
        key: string | string[];
        separator?: string;
    };
	groupKey?: string;

	constructor() {
		super();

		this.groupKey = null;
	}
}